// ! Helpers

import {
    mapFbiToClass,
    mapFdrToClass,
    mapTempToClass
} from '../query-colour-mapper';

import {
    getDisplayValue
} from '../format-display-value';

/**
 * ! NOTE 
 * Both the min and max daily temperature layers are labelled 'temperature'
 * which is confusing. Ordering for these layers is as follows:
 * 1. Daily max temperature
 * 2. Daily min temperature
 * 3. Max FBI
 * 4. Max FDR
 * 
 * The summary table does NOT use the google charts API, it is purely an
 * HTML table
 * @param {*} dailyData 
 */
export function drawSummaryTable(dailyData, chartContainer) {
    const rowsToAdd = [{}, {}, {}, {}];

    // The initial row is to ensure there are 5 columns for every row
    const headerRow = ['<div class="summary-table-cell"></div>'];
    const weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    for(let i = 0; i < dailyData[0].length; i++) {
        
        const currDailyData = new Date(dailyData[0][i].DateTime);
        const paddedDate = currDailyData.getDate().toString().padStart(2, '0');
        // The +1 here is because `.getMonth()` starts from 0
        const paddedMonth = (currDailyData.getMonth() + 1).toString().padStart(2, '0')
        const formattedDate = `${weekday[currDailyData.getDay()]} ${paddedDate}/${paddedMonth}`;
        headerRow.push($(
            `<div class="summary-table-cell"> ${formattedDate}</div>`
        ));
    }

    // 4 because we're only grabbing 4 layers
    for(let i = 0; i < 4; i++) {
        for(let j = -1; j < dailyData[i].length; j++) {
            let currDailyData;
            if(j !== -1) {
                currDailyData = dailyData[i][j];
            }
            
            switch(i) {
                case 0:
                    if(j == -1) {
                        rowsToAdd[i]['type'] = 'max_temperature';
                        rowsToAdd[i]['data'] = [];
                        rowsToAdd[i]['data'].push(
                            {
                                'value': 'Max <sup>o</sup>C',
                                'className': 'no-data'
                            });
                        continue;
                    }
                    // Daily max temp
                    rowsToAdd[i]['data'].push({
                        'value': getDisplayValue(currDailyData.Temperature, 'Temp'),
                        'className': mapTempToClass(currDailyData.Temperature)
                    });
                    break;
                case 1:
                    if(j == -1) {
                        rowsToAdd[i]['type'] = 'min_temperature';
                        rowsToAdd[i]['data'] = [];
                        rowsToAdd[i]['data'].push({
                            'value': 'Min <sup>o</sup>C',
                            'className': 'no-data'
                        });
                        continue;
                    }
                    // Daily min temp
                    rowsToAdd[i]['data'].push({
                        'value': getDisplayValue(currDailyData.Temperature, 'Temp'),
                        'className': mapTempToClass(currDailyData.Temperature)
                    });
                    break;
                case 2:
                    if(j == -1) {
                        rowsToAdd[i]['type'] = 'max_fbi';
                        rowsToAdd[i]['data'] = [];
                        rowsToAdd[i]['data'].push({
                            'value': 'Max FBI',
                            'className': 'no-data'
                        });
                        continue;
                    }
                    // Max FBI
                    rowsToAdd[i]['data'].push({
                        'value': getDisplayValue(currDailyData.FBI, 'FBI'),
                        'className': mapFbiToClass(currDailyData.FBI)
                    });
                    break;
                case 3:
                    if(j == -1) {
                        rowsToAdd[i]['type'] = 'max_fdr';
                        rowsToAdd[i]['data'] = [];
                        rowsToAdd[i]['data'].push({
                            'value': 'Max FDR',
                            'className': 'no-data'
                        });
                        continue;
                    }
                    // Max FDR
                    rowsToAdd[i]['data'].push({
                        'value': getDisplayValue(currDailyData.FDR, 'FDR'),
                        'className': mapFdrToClass(currDailyData.FDR)
                    });
                    break;
                default:
                    console.error(`Unmapped layer: ${i}`);
            }
        }
    }

    // This array controls the order that the layers are displayed
    const tableOrder = ['max_fdr', 'max_fbi', 'max_temperature', 
            'min_temperature'];

    const tableHtml = $(`<div class="no-data chart-container-style"></div>`);

    // Add the header row
    const headerRowHtml = $(`<div class="summary-table-row"></div>`);
    headerRow.forEach((item) => {
        headerRowHtml.append(item);
    });
    tableHtml.append(headerRowHtml);

    // Add the data layers
    tableOrder.forEach((item) => {
        const dataRow = rowsToAdd.find(e => e['type'] == item);

        if(dataRow == undefined) {
            console.error(`Error trying to find : ${item} data row`);
            return;
        }

        const dataRowHtml = $(`<div class="summary-table-row"></div>`);
        dataRow['data'].forEach((dataCol) => {
            dataRowHtml.append(
                $(`<div class="${dataCol['className']} summary-table-cell">` + 
                    `${dataCol['value']}` + 
                `</div>`)
            );
        })
        tableHtml.append(dataRowHtml);
    });

    chartContainer.append(tableHtml);
}